$(document).ready(function() {
  var $slider;
  var isFastSwipe = false;

var $slider = null; // Initialize the variable for the Flickity instance

function initFlickity() {
  if (!$slider) {
    var options = {
      pageDots: true,
      cellAlign: 'left',
      wrapAround: false,
      prevNextButtons: false,
      contain: true,
      draggable: true,
      groupCells: false,
      dragThreshold: 10,
    };

    if (window.innerWidth <= 767) {
      options.freeScroll = true;
    } else {
      options.prevNextButtons = true;
      options.freeScroll = false;
    }

    requestAnimationFrame(function() {
      // Initialize Flickity and store the instance in $slider
      $slider = $('.gb-productmain-slider').flickity(options);
    });
  }

  // Select all thumbnail images with the class .thumb
  var thumbnailimg = document.querySelectorAll('.swiper-slide');
  
  // Iterate over each thumbnail and add the event listener
  thumbnailimg.forEach(function(button) {
    button.addEventListener('click', function() {
      $(".active_thumb").removeClass("active_thumb");
      var index = parseInt(button.getAttribute('data-media-id'), 10);
       $(this).addClass("active_thumb");
      if ($slider) {
        $slider.flickity('select', index-1); // Scroll to the specific slide
      }
    });
  });
}

initFlickity();



});

/*-------------------------------------------------------*/
$(document).ready(function() {
  var $productSlider;

  function initFlickity() {
    if (!$productSlider) {
      var options = {
        cellAlign: 'left',
        contain: true,
        draggable: true,
        selectedAttraction: 0.02,
        friction: 0.28,
        groupCells: 1, // Default to showing 1 cell at a time (mobile)
        wrapAround: false,
        freeScroll: true, // Enable free scroll for both mobile and desktop
      };

      // Desktop view settings (when window width is greater than 767px)
      if (window.innerWidth > 767) {
        options.pageDots = false;
        options.prevNextButtons = true;
         options.pageDots = true;
        options.groupCells = 1; // Ensure 1 slide at a time on desktop as well
      } else {
        // Mobile view settings (when window width is <= 767px)
        options.pageDots = true;
        options.prevNextButtons = false;
      }

      requestAnimationFrame(function() {
        $productSlider = $('.gd-product-main-coll').flickity(options);

        // Check for last slide and disable next arrow
        $productSlider.on('select.flickity', function(event, index) {
          var flkty = $productSlider.data('flickity');
          var isLastSlide = (index === flkty.slides.length - 1);
          
          if (isLastSlide) {
            $('.flickity-button.next').prop('disabled', true);
          } else {
            $('.flickity-button.next').prop('disabled', false);
          }
        });

        // Disable click during drag to prevent accidental clicks
        var isDragging = false;
        $productSlider.on('dragStart.flickity', function() {
          isDragging = true;  // Set flag when drag starts
        });

        $productSlider.on('dragEnd.flickity', function() {
          isDragging = false; // Reset flag when drag ends
        });

        // Ensure that clicks are only processed after dragging has ended
        $productSlider.on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
          if (isDragging) return; // Ignore click events during dragging
          
          if (!cellElement) return; // If no cell was clicked, do nothing
          
          // Your custom click behavior (e.g., open a link or show a modal) can go here
          console.log("Clicked on slide " + cellIndex);
        });
      });
    }
  }

  initFlickity();
});
/*==========================================*/
$(document).ready(function() {
  var $gbProductSlider;

  function initFlickity() {
    if (!$gbProductSlider) {
      var options = {
        cellAlign: 'left',
        contain: true,
        draggable: true,
        selectedAttraction: 0.02,
        friction: 0.28,
        groupCells: 1, // Default to showing 1 cell at a time (mobile)
        wrapAround: false,
        freeScroll: true, // Enable free scroll for both mobile and desktop
      };

      // Desktop view settings (when window width is greater than 767px)
      if (window.innerWidth > 767) {
        options.pageDots = false;
        options.prevNextButtons = true;
         options.pageDots = true;
        options.groupCells = 2; // Ensure 1 slide at a time on desktop as well
      } else {
        // Mobile view settings (when window width is <= 767px)
        options.pageDots = true;
        options.prevNextButtons = false;
      }

      requestAnimationFrame(function() {
        $gbProductSlider = $('.gb-image-with-product').flickity(options);

        // Check for last slide and disable next arrow
        $gbProductSlider.on('select.flickity', function(event, index) {
          var flkty = $gbProductSlider.data('flickity');
          var isLastSlide = (index === flkty.slides.length - 1);
          
          if (isLastSlide) {
            $('.flickity-button.next').prop('disabled', true);
          } else {
            $('.flickity-button.next').prop('disabled', false);
          }
        });

        // Disable click during drag to prevent accidental clicks
        var isDragging = false;
        $gbProductSlider.on('dragStart.flickity', function() {
          isDragging = true;  // Set flag when drag starts
        });

        $gbProductSlider.on('dragEnd.flickity', function() {
          isDragging = false; // Reset flag when drag ends
        });

        // Ensure that clicks are only processed after dragging has ended
          $gbProductSlider.on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
          if (isDragging) return; // Ignore click events during dragging
          
          if (!cellElement) return; // If no cell was clicked, do nothing
          
          // Your custom click behavior (e.g., open a link or show a modal) can go here
          console.log("Clicked on slide " + cellIndex);
        });
      });
    }
  }

  initFlickity();
});
/*===================related product slider=======================*/

$(document).ready(function() {
  var $relatedSlider;

  function initFlickity() {
    if (!$relatedSlider) {
      var options = {
        cellAlign: 'left',
        contain: true,
        draggable: true,
        selectedAttraction: 0.02,
        friction: 0.28,
        groupCells: 1, // Default to showing 1 cell at a time (mobile)
        wrapAround: false,
        freeScroll: true, // Enable free scroll for both mobile and desktop
      };

      // Desktop view settings (when window width is greater than 767px)
      if (window.innerWidth > 767) {
        options.pageDots = false;
        options.prevNextButtons = true;
         options.pageDots = true;
        options.groupCells = 4; // Ensure 4 slide at a time on desktop as well
      } else {
        // Mobile view settings (when window width is <= 767px)
        options.pageDots = true;
        options.prevNextButtons = false;
      }

      requestAnimationFrame(function() {
        $relatedSlider = $('.product_recommendation_slick').flickity(options);

        // Check for last slide and disable next arrow
        $relatedSlider.on('select.flickity', function(event, index) {
          var flkty = $relatedSlider.data('flickity');
          var isLastSlide = (index === flkty.slides.length - 1);
          
          if (isLastSlide) {
            $('.flickity-button.next').prop('disabled', true);
          } else {
            $('.flickity-button.next').prop('disabled', false);
          }
        });

        // Disable click during drag to prevent accidental clicks
        var isDragging = false;
        $relatedSlider.on('dragStart.flickity', function() {
          isDragging = true;  // Set flag when drag starts
        });

        $relatedSlider.on('dragEnd.flickity', function() {
          isDragging = false; // Reset flag when drag ends
        });

        // Ensure that clicks are only processed after dragging has ended
        $relatedSlider.on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
          if (isDragging) return; // Ignore click events during dragging
          
          if (!cellElement) return; // If no cell was clicked, do nothing
          
          // Your custom click behavior (e.g., open a link or show a modal) can go here
          console.log("Clicked on slide " + cellIndex);
        });
      });
    }
  }

  initFlickity();


});





 
 